import { SelectAsyncInput } from '@core/components/Select';
import { reguaCobrancaApi } from 'app/services/api/reguaCobrancaApi';
import React from 'react';

const SelectReguaCobranca = ({
  id,
  name,
  label,
  value,
  touched,
  error,
  onBlur,
  onChange,
  required,
  autoFocus,
  disabled,
  multiple,
}) => {
  return (
    <SelectAsyncInput
      id={id}
      multiple={multiple}
      autoFocus={autoFocus}
      required={required}
      disabled={disabled}
      name={name}
      label={label}
      value={value}
      onChange={(event, valor) => {
        onChange({
          target: {
            id,
            value: valor,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        return option.nome;
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }
        const response = await reguaCobrancaApi().buscarReguasCobrancas({
          size: 1000,
          sort: 'nome,asc',
          page: 0,
          q: query?.length ? query : '',
          ativo: true,
        });
        const totalItems = response.headers['x-total-count'];
        const data = response?.data?.content || [];

        return { data, totalItems };
      }}
      fetchOnFocus
    />
  );
};

export default SelectReguaCobranca;
